import constants from 'config/constants';

const redirectUri = constants.ENV === 'local' ? 'http://localhost' : `${constants.BASE_API_URL}/v1`;

export default {
  client_id: '309762081129-n5bge0hs3m93umig3q4kb6ln9vuro51v.apps.googleusercontent.com',
  redirect_uri: `${redirectUri}/oauth/google`,
  response_type: 'code',
  scope: 'https://www.googleapis.com/auth/calendar',
  access_type: 'offline',
  oauth_route: 'https://accounts.google.com/o/oauth2/v2/auth',
  prompt: 'consent',
};
